import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemList from '../../Item-List';
import { useKanban } from 'hooks/useKanban';

const Audience = ({
  id,
  name: initialName,
  description: initialDescription,
  setItems,
  index,
  isNew,
  setSelectedItem,
  setIsOpenModalDelete,
  setStatus,
}) => {
  const { kanban: paidMedia } = useKanban();
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription || '');

  const addAudience = async () => {
    const response = await paidMedia.createTypeItem('audiences', { name, description });

    return {
      id: response.id,
      name,
      description,
      isNew: false,
    };
  };

  const updateAudience = async () => {
    return await paidMedia.updateTypeItem('audiences', id, { name, description });
  };

  return (
    <ItemList
      id={id}
      initialName={initialName}
      name={name}
      setName={setName}
      initialDescription={initialDescription}
      description={description}
      setDescription={setDescription}
      setItems={setItems}
      index={index}
      isNew={isNew}
      setSelectedItem={setSelectedItem}
      setIsOpenModalDelete={setIsOpenModalDelete}
      setStatus={setStatus}
      addItem={addAudience}
      updateItem={updateAudience}
      textSaveButton="Add audience"
    />
  );
};

Audience.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  setItems: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isNew: PropTypes.bool,
  setSelectedItem: PropTypes.func.isRequired,
  setIsOpenModalDelete: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default Audience;
